import { Link } from 'react-router-dom';

interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  actionPath?: string;
}

export default function EmptyState({ title, description, actionLabel, onAction, actionPath }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100/60 px-6 py-20 text-center">
      <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-400">
        <i className="ri-file-search-line text-3xl" />
      </div>
      <h3 className="text-base font-medium text-foreground-900">{title}</h3>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">{description}</p>
      {actionLabel && actionPath && (
        <Link
          to={actionPath}
          className="mt-6 inline-flex cursor-pointer items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      )}
      {actionLabel && !actionPath && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-6 inline-flex cursor-pointer items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          {actionLabel}
          <i className="ri-refresh-line text-sm" />
        </button>
      )}
    </div>
  );
}